import { Chip } from "@mui/material";

// Marks a widget whose student-scoped read API doesn't exist yet, so it
// renders an empty state instead of real data. Remove per-widget once that
// widget has a real hook wired in.
export const PlaceholderBadge = () => (
  <Chip label="Coming soon" size="small" sx={{ height: 22, fontSize: 11, fontWeight: 600, bgcolor: "#eef2f6", color: "#475569" }} />
);
